<template>
  <div>
    <!-- Selector de sensores -->
    <b-row>
      <b-col cols="6">
        <p class="text-left">Desviaciones respecto a la frecuencia natural saludable</p>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="selSensor text-right">Seleccionar sensor</b-col>
          <b-col>
            <b-form-select
              size="sm"
              id="sensors"
              name="sensors"
              v-model="selectedSensor"
              style="cursor: pointer"
            >
              <b-form-select-option value="null">
                Sensor no seleccionado
              </b-form-select-option>

              <b-form-select-option
                v-for="(sensor, index) in sensorList"
                v-bind:key="index"
                v-bind:value="sensor"
              >
                {{ sensor.description }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Tabla con la lista de dispositivos-->
    <div>
      <vue-good-table
        id="shmTable"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :columns="columns"
        :rows="rows"
        ref="shmData"
        :search-options="{
          skipDiacritics: true,
          placeholder: 'Buscar en la tabla',
        }"
        :pagination-options="{
          mode: 'records',
          enabled: true,
          nextLabel: '',
          prevLabel: '',
          perPage: 10,
          rowsPerPageLabel: 'Filas por pagina',
          ofLabel: 'de',
          pageLabel: 'pagina', // for 'pages' mode
          allLabel: 'Todas',
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'raw_ts', type: 'desc' },
        }"
        :isLoading.sync="isLoading"
      >
        <template slot="loadingContent">
          <table-loading />
        </template>
        <template slot="emptystate">
          <table-empty-state />
        </template>
      </vue-good-table>
    </div>
  </div>
</template>


<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import GroupService from "@/services/GroupService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "desv-list",
  data() {
    return {
      selectedSensor: null,
      sensorList: [],
      idsensor: null,
      idgroup: null,
      totalRecords: 0,
      isLoading: false,
      columns: [
        {
          label: "# UUID",
          thClass: "text-center",
          tdClass: "text-center",
          field: "uuid",
          hidden: true,
        },
        {
          label: "Fecha",
          field: "raw_ts",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "200px",
        },
        {
          label: "Freq 1 / Desv",
          field: "desviacion1",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
        },

        {
          label: "Freq 2 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion2",
        },
        {
          label: "Freq 3 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion3",
        },
        {
          label: "Freq 4 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion4",
        },
        {
          label: "Freq 5 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion5",
        },
        {
          label: "Freq 6 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion6",
        },
        {
          label: "Freq 7 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion7",
        },
        {
          label: "Freq 8 / Desv",
          thClass: "text-center",
          tdClass: "text-center",
          field: "desviacion8",
        },
      ],
      rows: [],
      serverParams: {
        columnFilters: {},
        sort: {
          field: "raw_ts",
          type: "desc",
        },
        page: 1,
        perPage: 10,
      },
    };
  },
  components: {
    VueGoodTable,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
  },
  watch: {
    selectedSensor: function (newVal, oldVal) {
      return this.retrieveShmFromSensor(newVal);
    },
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      if (this.selectedSensor) {
        this.updateParams({ page: params.currentPage });
        this.loadItems();
      }
    },

    onPerPageChange(params) {
      if (this.selectedSensor) {
        this.updateParams({ perPage: params.currentPerPage });
        this.loadItems();
      }
    },

    async onSortChange(params) {
      //onSortChange executes before retrieveDataFromSensor (which prepares the metadata neccesary), so it have to wait
      if (this.selectedSensor) {
        if (this.columns.length && this.columns.length > 0) {
          this.updateParams({
            page: 1,
            sort: {
              type: params[0].type,
              field: params[0].field,
            },
          });
          this.loadItems();
        }
      }
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    async loadItems() {
      this.isLoading = true;
      await GroupService.getFreqDeviationsBySensorId(
        this.selectedSensor._id,
        this.serverParams
      )
        .then((filteredData) => {
          let data = filteredData.data;
          this.totalRecords = data.totalRecords;
          this.populateRows(data.data);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(
            "Error getting filtered data (DesvFreq.vue :: loadItems)"
          );
          console.log(err);
        });
    },

    /* Rellenar la tabla con los datos del backend*/
    async retrieveShmFromSensor(sensor) {
      this.rows = [];

      await GroupService.getFreqDeviationsBySensorId(
        sensor._id,
        this.serverParams
      )
        .then((filteredData) => {
          let dataResponse = filteredData.data;
          this.totalRecords = dataResponse.totalRecords;
          this.populateRows(dataResponse.data);
        })
        .catch((e) => {
          console.log("Error recuperando datos shm filtrados");
          console.log(e);
        });
    },

    //Llenar el listado del desplegable, metemos el objeto completo para tenerlo todo identificado
    //Solo llenamos el array con los elementos SHM
    async populateSelector(groupData) {
      this.sensorList = [];
      for await (let sensor of groupData.sensor)
        if(sensor.isShm){
            this.sensorList.push(sensor)
        }
      // Seleccionar un elemento como primario para desplegarlo
      this.selectedSensor = this.sensorList[0]        
    },   

    async populateRows(data) {
      this.rows = [];

      //Add to array
      for (let i = 0; i < data.length; i++) {
        let d = data[i];

        //Create struct before insert it
        let newData = null;

        newData = {
          raw_ts: this.$moment(String(d.raw_ts))
            .local()
            .format("DD-MM-YYYY HH:mm:ss.SSS"),
          desviacion1: d.data.desviacion1 ? d.data.desviacion1 : " - ",
          desviacion2: d.data.desviacion2 ? d.data.desviacion2 : " - ",
          desviacion3: d.data.desviacion3 ? d.data.desviacion3 : " - ",
          desviacion4: d.data.desviacion4 ? d.data.desviacion4 : " - ",
          desviacion5: d.data.desviacion5 ? d.data.desviacion5 : " - ",
          desviacion6: d.data.desviacion6 ? d.data.desviacion6 : " - ",
          desviacion7: d.data.desviacion7 ? d.data.desviacion7 : " - ",
          desviacion8: d.data.desviacion8 ? d.data.desviacion8 : " - ",
        };

        //Push the data to the array
        this.rows.push(newData);
      }
    },
  },
};
</script>

<style>
.groupTable {
  padding: 20px 20px 20px 20px;
}
.titulo {
  position: absolute;
  margin-top: -35px;
  margin-left: 340px;
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}
.selSensor {
  padding: 3px;
  font-size: 0.95rem;
  color: #606266;
  font-weight: 400;
}
</style>
